const Component = ({ id, title, children, onCancel, onProceed }) => {
  return (
    <>
      <div className="modal fade" tabIndex="-1" role="dialog" id={id}>
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <a href="#" className="close" data-dismiss="modal">
              <em className="icon ni ni-cross-sm"></em>
            </a>

            <div className="modal-body modal-body-md">
              {title && <h6 className="title">{title}</h6>}
              {children}
            </div>

            {/* Modal Footer */}
            <div className="modal-footer justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                data-dismiss="modal"
                onClick={onCancel}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={onProceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Component;
